import React from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import API from "../../../util/api";
import { useNavigate } from "react-router-dom";
import { becomeUser, setBecomeOrigin } from "../../../sagas/actions";
import { actionContainerStyles, actionLinkStyles, actionHeaderStyles } from "../common/ActionStyles";
import ResponsiveActions from "../common/ResponsiveActions";
import { showErrorModal } from "../../../util/general";
import { FILES_BASE_URL } from "../../../util/constant";

const LINK_HOVER_COLOR = "#F7941D";

const breakpoints = {
  tablet: 768,
  phone:  480,
};

const Sidebar = styled.div`
  ${actionContainerStyles};

  h3 {
    ${actionHeaderStyles};
    border-bottom: 1px solid ${({ colors }) => colors.border};
  }

  ul {
    margin: 0;
    list-style: none;
    padding: 12px 16px;
  }

  li + li {
    margin-top: 4px;
  }

  a {
    ${actionLinkStyles};
    padding-left: 16px;
    color: #2C4960;

    &:hover {
      color: ${LINK_HOVER_COLOR};
    }
  }
  @media (min-width: ${breakpoints.tablet}px) {
    flex: 0 0 260px;
  }
`;

export default function ActionMenu({
  colors,
  onModeChange,
  onMassCertify,
  onMassUncertify,
  onSendWelcomeEmails,
  mode,
  selectedTeacher,
}) {
  const subscription = useSelector((state) => state.auth.selected_subscriptions) || {};
  const invoiceId = subscription.invoice_id;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleBecome = () => {
    if (!selectedTeacher) return;
    dispatch(setBecomeOrigin("subscription"));
    dispatch(becomeUser(selectedTeacher.user_id));
    navigate("/myinfo");
  };

  const handleDownloadBlankStat = () => {
    // direct download of the CSV from the server
    window.location.href =
      `${FILES_BASE_URL}/ISAFE_STAT_Sheet.csv`;
  };
  const handleExport = () => {
    if (!invoiceId) {
      showErrorModal("No subscription selected.");
      return;
    }
    API.exportTeachersList({ invoice_id: invoiceId })
      .then(resp => {
        const url = resp.file;
        if (!url) throw new Error("No file URL returned");
        // trigger browser download
        window.location.href = url;
      })
      .catch(err => {
        console.error("Export failed:", err);
        showErrorModal(
          "Failed to export teacher list: " + (err.message || "")
        );
      });
  };

  if (mode === "detail" && selectedTeacher) {
    return (
      <ResponsiveActions
        colors={colors}
        mobileToggleTop={-25}
        mobileToggleLeft={-25}
        renderActions={() => (
          <Sidebar colors={colors}>
            <h3>Actions</h3>
            <ul>
              <li>
                <a onClick={handleBecome}>Become</a>
              </li>
            </ul>
          </Sidebar>
        )}
      />
    );
  }

  if (mode === "resetPassword" && selectedTeacher) {
    return null
  }

  return (
    <ResponsiveActions
      colors={colors}
      renderActions={() => (
        <Sidebar colors={colors}>
          <h3>Actions</h3>
          <ul>
            <li><a onClick={() => onModeChange("list")}>List Teachers</a></li>
            <li><a onClick={() => onModeChange("add")}>Add Teacher</a></li>
            <li><a onClick={() => onModeChange("remove")}>Remove Teacher</a></li>
            <li><a onClick={() => onModeChange("import")}>Import Teacher List</a></li>
            <li><a onClick={handleExport}>Export Teacher List</a></li>
            <li>
              <a onClick={onMassCertify}>
                Certify All Downloads
              </a>
            </li>
            <li><a onClick={onMassUncertify}>Uncertify All Downloads</a></li>
            <li><a onClick={onSendWelcomeEmails}>Send Welcome Email</a></li>
            <li><a onClick={() => onModeChange("upload")}>Uploads</a></li>
            <li>
              <a onClick={handleDownloadBlankStat}>Download Blank STAT</a>
            </li>
          </ul>

          <h3 style={{ overflow: 'hidden', borderRadius: 0 }}>*Students/Grades</h3>
          <ul style={{ fontSize: "10px" }}>
            <li>
              <span style={{ textDecoration: "underline" }}>
                Underscore
              </span>{" "}
              = Curriculum Downloaded
            </li>
            <li>&nbsp;</li>
            <li>
              <span style={{ fontWeight: "bold" }}>BOLD</span> = Certified Complete
            </li>
            <li>&nbsp;</li>
          </ul>
        </Sidebar>
      )}
    />
  );
}
